import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/margin-of-safety-calculator',
  component: () => import('../../routes/MarginOfSafetyCalculator.svelte'),
  card: {
    id: 'margin-of-safety-calculator',
    title: 'Margin of Safety Calculator',
    description: 'Calculate the margin of safety for value investments using Benjamin Graham\'s principle.',
    icon: 'shield',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/margin-of-safety-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Margin of Safety Calculator – Value Investing Tool',
    description: 'Free margin of safety calculator based on Benjamin Graham\'s investing principle. Find the cushion between intrinsic value and market price to make safer investment decisions.',
  },
};

export default meta;